module.exports = __webpack_public_path__ + "img/logo.04d43016.jpg";